import type { Units } from './types';

const KM_PER_MILE = 1.609344;

/** Milliseconds → "m:ss" (minutes are not capped at 59). */
export function formatTime(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export const kmToMiles = (km: number): number => km / KM_PER_MILE;

/** "12 km", "1,234 km", "0.4 mi" — whole numbers above 10, one decimal below. */
export function formatDistance(km: number, units: Units): string {
  const value = units === 'mi' ? kmToMiles(km) : km;
  const text = value < 10 ? value.toFixed(1) : Math.round(value).toLocaleString('en-GB');
  return `${text} ${units}`;
}

export function formatYearsOff(yearDiff: number): string {
  const n = Math.abs(yearDiff);
  if (n === 0) return 'Exact year';
  return `${n} ${n === 1 ? 'year' : 'years'} off`;
}

/** "14-day streak" style pluralisation helper. */
export function plural(n: number, singular: string, pluralForm = `${singular}s`): string {
  return `${n} ${n === 1 ? singular : pluralForm}`;
}

/** Default units: miles when the browser locale is en-US, km otherwise (PRD §10). */
export function defaultUnitsForLocale(locale: string | undefined): Units {
  return locale?.toLowerCase() === 'en-us' ? 'mi' : 'km';
}
